import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";


// components
import SectionList from "./_list";
import {showLoader} from "../../../components/loader/loader";


// actions
import {ADD_STATE, REMOVE_STATE, setUdn, setApp, setUserIsAdmin} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";


const Section = (props) => {
    const path = "/landing/section";
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        const cockie = localStorage.getItem('selectedUdn');

        try {
            if (cockie !== "undefined") {
                const _udn = JSON.parse(cockie);
                props.setUdn(path, _udn);
            }
        } catch (ex ) {
            console.error(ex);
        }

        if (props.app !== null)
            props.setApp(path, props.app);
    },[]);


    return <>
        {loading && showLoader()}
        { componentState && <SectionList path={path} /> }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin,
})

export default connect(mapStateToProps, mapActionsToProps)(Section);